import React, { useState, useEffect } from "react"
import postscribe from "postscribe";
import PageHeaders from "../common/PageHeaders"
import Menu from "../common/Menu"
import Header from "../components/Header"
import Footer from "../components/Footer"
import card from "../images/tomo_card_green.svg"

const About = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    postscribe(
      "#jazz",
      '<script type="text/javascript" src="https://app.jazz.co/widgets/basic/create/tomocredit" charset="utf-8"></script>',
      {
        done: () => console.log("jazz hr script loaded")
      }
    );
  }, []);

  return (
    <>
      <PageHeaders type="careers" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={state => {
              setMenuOpen(state.isOpen)
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="topSection bg-primary" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle="About" />
          </div>
          <div className="flex mt-32 lg:mt-24">
            <main className="w-full text-dark pt-16">
              <section className="mb-20 px-10 max-w-page py-5">
                <p className="text-xl font-normal  mb-2 text-center uppercase">
                  Careers
                </p>
                <h1 className="text-3xl md:text-5xl  font-bold text-center w-10/12 mx-auto">
                  We are hiring!
                </h1>
              </section>

              {/* <section className="w-full bg-white px-10 pt-20 pb-5 hidden md:block">
                <div className="md:flex md:items-stretch max-w-page pb-5 border-b-2 border-gray-800">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-xl">Job Title</h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg">
                    <h3 className="font-bold text-xl">Description</h3>
                  </div>
                  <div className="w-3/12 self-center font-normal text-lg">
                    <h3 className="" />
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-20 pb-5 block md:hidden">
                <div className="md:flex md:items-stretch max-w-page pb-5 border-b-2 border-gray-800">
                  <div className="w-full self-center">
                    <h3 className="font-bold text-xl">
                      Job Title &amp; Description
                    </h3>
                  </div>
                </div>
              </section>


              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://www.linkedin.com/jobs/view/2383858241/"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Staff Full Stack Software Engineer
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for an experienced Node.js developer with
                      strong front-end skills to join our small and creative
                      team&hellip;
                      <a
                        href="https://www.linkedin.com/jobs/view/2383858241/"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://www.linkedin.com/jobs/view/2383858241/"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1091462-senior-data-engineer"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Senior Data Engineer
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for an experienced data engineer with strong SQL skills to join our small and creative
                      team&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1091462-senior-data-engineer"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1091462-senior-data-engineer"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1091459-support-engineer"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Support Engineer
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for an javascript/Node.js developer with good SQL and API skills to join our small and creative team.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1091459-support-engineer"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1091459-support-engineer"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1117294-head-of-risk"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Head of Risk
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for an experienced leader to manage the Risk and Analytics to at Tomo.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1117294-head-of-risk"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1117294-head-of-risk"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1118197-product-manager"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Senior Product Manager
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for looking for a Product Manager to help build and scale the credit card of TOMOrrow.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1118197-product-manager"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1118197-product-manager"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1095461-financial-analyst"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Financial Analyst
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for a financial guru with good modeling and analytical skills to join our small and creative team.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1095461-financial-analyst"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1095461-financial-analyst"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1095471-business-analyst"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Business Analyst
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for a business-oriented, self-driven individual to help build and scale the credit card of TOMOrrow.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1095471-business-analyst"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1095471-business-analyst"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1121829-customer-service-agent"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Senior Customer Service Agent
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We're looking for someone with a proven track record of interacting with customers to join our customer support team.&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/1121829-customer-service-agent"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/1121829-customer-service-agent"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/910836-growth-marketing-intern-remote"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Growth Marketing Intern
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We are looking for a Growth Marketing Intern (remote) to join our
                      fast-paced marketing team. An ideal candidate would be a
                      current college or graduate student who is
                      entrepreneurial-minded and passionate about consumer
                      fintech&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/910836-growth-marketing-intern-remote"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/910836-growth-marketing-intern-remote"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section>

              <section className="w-full bg-white px-10 pt-5 pb-16">
                <div className="md:flex md:items-stretch max-w-page">
                  <div className="md:w-4/12 self-center">
                    <h3 className="font-bold text-lg mb-2 md:mb-0">
                      <a
                        href="https://angel.co/company/tomocredit/jobs/910712-graphic-design-intern-remote"
                        target="_blank"
                        className="hover:text-primary"
                      >
                        Graphic Design Intern
                      </a>
                    </h3>
                  </div>
                  <div className="md:w-5/12 self-center font-normal text-lg pr-2">
                    <p className="text-base">
                      We are looking for a Graphic Design Intern (remote) to join our
                      fast-paced marketing/design team. An ideal candidate would be a
                      current college or graduate student who is
                      entrepreneurial-minded and passionate about consumer
                      fintech&hellip;
                      <a
                        href="https://angel.co/company/tomocredit/jobs/910712-graphic-design-intern-remote"
                        target="_blank"
                        className="underline hover:text-primary ml-1"
                      >
                        Read more
                      </a>
                    </p>
                  </div>
                  <div className="md:w-3/12 self-center font-normal text-lg md:text-center mt-8 md:mt-0">
                    <a
                      href="https://angel.co/company/tomocredit/jobs/910712-graphic-design-intern-remote"
                      target="_blank"
                      className="text-center bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded shadow-md"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </section> */}

              <section className="w-full bg-white px-10 pt-5 pb-5 block">
                {/* <div className="max-w-page pb-5 border-b-2 border-gray-800">
                  <h3 className="font-bold text-xl">
                    More Jobs
                  </h3>
                </div> */}
                <div className="md:flex md:items-stretch max-w-page">
                  <div id="jazz" className="w-full bg-white px-10 pt-5 pb-1"></div>
                </div>
              </section>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default About
